var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"dashbord-galary__item page-tab",attrs:{"to":_vm.tabData.route}},[_c('i',{class:_vm.tabData.icon}),_vm._v(" "+_vm._s(_vm.tabData.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }